import type { RouteConfig } from 'vue-router';

export default [
  /**
   * H5渠道落地页
   */
  {
    path: '/channel/entrance',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/universal.vue'),
  },
  // /**
  //  * H5渠道落地页(新版)
  //  */
  // {
  //   path: '/channel/partner',
  //   meta: {
  //     excludeLogin: true,
  //   },
  //   component: () => import('@/views/channel/partner/index.vue'),
  // },
  // /**
  //  * H5渠道落地页(新版)
  //  */
  // {
  //   path: '/channel/partner/download-app',
  //   meta: {
  //     excludeLogin: true,
  //   },
  //   component: () => import('@/views/channel/partner/download-app.vue'),
  // },
  /**
   * H5渠道联合登录落地页
   */
  {
    path: '/channel/federated',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/federated/index.vue'),
  },
  /**
   * H5渠道联合登录落地页-拒绝登录
   */
  {
    path: '/channel/federated/rejected',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/federated/rejected.vue'),
  },
  /**
   * 商通贷渠道落地页
   */
  {
    path: '/channel/std',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/std.vue'),
  },
  /**
   * 电销渠道落地页
   */
  {
    path: '/channel/telemarketing',
    meta: {
      title: '宜享花大额用户申请通道',
      excludeLogin: true,
    },
    component: () => import('@/views/channel/telemarketing.vue'),
  },
  /**
   * 联洗自落地页
   */
  {
    path: '/channel/api-to-origin',
    meta: {
      title: '优质用户专享活动',
      excludeLogin: true,
    },
    component: () => import('@/views/channel/api-to-origin.vue'),
  },
] as RouteConfig[];
